export enum RequestMethod {
  get = 'GET',
  patch = 'PATCH',
  post = 'POST',
  delete = 'DELETE',
}
